"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandRequirementsModelToJSON = exports.HandRequirementsModelFromJSONTyped = exports.HandRequirementsModelFromJSON = void 0;
function HandRequirementsModelFromJSON(json) {
    return HandRequirementsModelFromJSONTyped(json, false);
}
exports.HandRequirementsModelFromJSON = HandRequirementsModelFromJSON;
function HandRequirementsModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'capturedCount': json['capturedCount'],
        'expectedCount': json['expectedCount'],
    };
}
exports.HandRequirementsModelFromJSONTyped = HandRequirementsModelFromJSONTyped;
function HandRequirementsModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'capturedCount': value.capturedCount,
        'expectedCount': value.expectedCount,
    };
}
exports.HandRequirementsModelToJSON = HandRequirementsModelToJSON;
//# sourceMappingURL=HandRequirementsModel.js.map